import { state } from 'cerebral/tags'
import { set } from 'cerebral/operators'
import isSelectedNodeAffected from '../actions/isSelectedNodeAffected'
import createSnackbar from 'modules/App/factories/createSnackbar'

export default [
  isSelectedNodeAffected,
  {
    true: [
      // Clears the view if node selected was moved
      set(state`node.selectedList`, {}),
      set(state`node.selectedNode`, { id: null, path: null }),
      set(state`media.files`, {}),
      createSnackbar({ key: 'bms.node.event.deselectedNode' }, 'warning')
    ],
    false: []
  }
]



// WEBPACK FOOTER //
// ./src/modules/Node/chains/deselectNodesOnChange.js